export default class Counter {
  constructor() {
    this._value = 1
  }
  get value() {
    return this._value++
  }
}